import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';
import { safeLocalStorage } from '@toss/storage';
import qs from 'query-string';

import { API_ENDPOINT, useClientApiV1UserDevicesQuery } from '../../resources/@types/uccSchema';
import { getDeviceTokenStorageKey } from '../components/pages/my/settings/device/getDeviceTokenStorageKey';
import useClientAccountProfileQuery from './useClientAccountProfileQuery';

interface UseClientV1UserDevicesQuery {
  options?: Parameters<typeof useClientApiV1UserDevicesQuery>[0]['options'];
}

export function useUserDevicesQuery({ options }: UseClientV1UserDevicesQuery = {}) {
  const { data: accountProfile } = useClientAccountProfileQuery();
  const tokenKey = getDeviceTokenStorageKey(accountProfile?.id ?? 0);
  const token = safeLocalStorage.get(tokenKey) ?? '';

  return useClientApiV1UserDevicesQuery({
    queryKey: getUserDevicesQueryKey(token),
    url: qs.stringifyUrl(
      {
        url: API_ENDPOINT.CLIENT_V1_USER_DEVICES,
        query: {
          token,
        },
      },
      {
        skipNull: true,
      },
    ),
    options: {
      ...options,
      enabled: !!accountProfile?.id,
    },
  });
}

export const getUserDevicesQueryKey = (token?: string): QueryKeyReturnType =>
  token ? [API_ENDPOINT.CLIENT_V1_USER_DEVICES, token] : [API_ENDPOINT.CLIENT_V1_USER_DEVICES];
